var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-tag',{attrs:{"gpt-id":"div-gpt-ad-1708520365809-0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }